import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { DwpService } from './dwp.service';
import { NotificationService } from '../../../shared/services/notification.service'
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentCanDeactivate } from '../../../shared/guard/unsaved-changes.guard';
import { Observable, Subject } from 'rxjs';
import { BaseComponentComponent } from '../../base-component/base-component.component';
import { SecurityService } from '../../../shared/services/security.service';
import { enumPermissions } from '../../../shared/models/common.enum';
import { ClaimHandlerService } from '../../../shared/services/claim-handler.service'

@Component({
  selector: 'app-dwp',
  templateUrl: './dwp.component.html',
  styleUrls: ['./dwp.component.css']
})
export class DwpComponent extends BaseComponentComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild(NgForm, { static: false })
  private form: NgForm;
  isShowSearchButton: boolean = false;
  isInEditMode: boolean = false;
  isValid: boolean = true;
  title: string;
  isDisabledFields: boolean = false;
  public autoClaimsHandlers: any[];

  saveMethod: any;
  isFormSubmitted: boolean = true;
  public formValidityFlagLoaded = new Subject();
  isValidInput$ = this.formValidityFlagLoaded.asObservable();
  isFormDirty(): boolean { return false; }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    this.saveMethod = this.onSubmit;

    let hasPendingChanges: boolean = !this.form.touched;
    return hasPendingChanges;
  }

  isMMIUser: boolean = false;
  canReadOnly: boolean = false;
  canEdit: boolean = false;
  canAdd: boolean = false;
  canDelete: boolean = false;
  isSettledButtonClicked: boolean = false;

  constructor(
    private dwpService: DwpService,
    private notificationService: NotificationService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    securityService: SecurityService
  ) {
    super(securityService, 1483);
  }


  ngOnInit(): void {
    if (this.securityService.getUserData() != null) {
      this.isMMIUser = this.securityService.getUserData().organisationId == 1 ? true : false;
    }
    //this.bindBACSDetailPermission();
    let id = this.activeRoute.snapshot.paramMap.get('dwpId');
    let isSearch = Boolean(this.activeRoute.snapshot.queryParams.isSearchFlag);
    let isEditFlag = this.activeRoute.snapshot.queryParams.editFlag;

    if (isSearch) {
      this.isShowSearchButton = true;
    }
    else {
      this.isShowSearchButton = false;

    }
    if (isEditFlag == "true") {
      this.isDisabledFields = true;
    }
    else {
      this.isDisabledFields = false;
    }
    if (id == null) {
      this.resetForm();
      this.isInEditMode = false;
    }
    else {
      this.initializeForm(id)
    }
    if (this.isInEditMode) {
      this.title = "Edit";
    } else { this.title = "Add"; }

  }

  bindBACSDetailPermission() {
    let userPermissionID: number = 1138;
    var userDetails = this.securityService.getUserData().userRolePermissionModels;
    var data = userDetails.filter(c => c.userPermissionsId == userPermissionID);
    this.permissionId = data[0].permission;
    if (this.permissionId == enumPermissions.Read) {
      this.canReadOnly = true;
    } else if (this.permissionId == enumPermissions.Edit) {
      this.canEdit = true;
    }
    else if (this.permissionId == enumPermissions.Add) {
      this.canAdd = true;
    }
    else if (this.permissionId == enumPermissions.Delete) {
      this.canDelete = true;
    }
  }

  onSubmit() {

    if (this.validateForm()) {
      if (this.dwpService.formData.id > 0) {
        this.dwpService.updateDwp().subscribe(res => {
          this.notificationService.printSuccessMessage('DWP details updated successfully');
          this.isInEditMode = true;
          this.isFormSubmitted = true;
          this.formValidityFlagLoaded.next();
          //this.bindBACSDetailPermission();
          this.form.form.markAsUntouched();
        },
          error => {
            this.notificationService.printErrorMessage("Error occured  in saving DWP Details");
          })

      }
      else {
        this.form.form.markAsUntouched();
        this.dwpService.createDwp().subscribe(res => {
          this.notificationService.printSuccessMessage('DWP details saved successfully');
          this.router.navigate(['/dwp/edit/' + res.id]);
        }),
          error => {
            this.notificationService.printErrorMessage("Error occured  in updating DWP Details");
          }
      }

    }
  }

  validateForm() {
    this.isValid = true;
    this.isFormSubmitted = true;
    if (this.dwpService.formData.dwpName == '' || this.dwpService.formData.dwpName == null ||
      this.dwpService.formData.accountNumber == '' || this.dwpService.formData.accountNumber == null ||
      this.dwpService.formData.bankName == '' || this.dwpService.formData.bankName == null ||
      this.dwpService.formData.bacsAddressFirstLine == '' || this.dwpService.formData.bacsAddressFirstLine == null ||
      this.dwpService.formData.bacsAddressPostCode == '' || this.dwpService.formData.bacsAddressPostCode == null ||
      this.dwpService.formData.bacsCountry == '' || this.dwpService.formData.bacsCountry == null ||
      this.dwpService.formData.bacsAddressTown == '' || this.dwpService.formData.bacsAddressTown == null ||
      this.dwpService.formData.country == '' || this.dwpService.formData.country == null ||
      this.dwpService.formData.firstLine == '' || this.dwpService.formData.firstLine == null ||
      this.dwpService.formData.sortCode == '' || this.dwpService.formData.sortCode == null ||
      this.dwpService.formData.town == '' || this.dwpService.formData.town == null ||
      this.dwpService.formData.postCode == '' || this.dwpService.formData.postCode == null ||
      !this.dwpService.formData.bacsEmail || this.dwpService.formData.bacsEmail == null) {
      this.isFormSubmitted = false;
      this.formValidityFlagLoaded.next();
      return this.isValid = false;
    }
    if (this.dwpService.formData.accountNumber.length < 8) {
      this.notificationService.printWarningMessage("Please enter 8 number account number");
      this.isFormSubmitted = false;
      this.formValidityFlagLoaded.next();
      return this.isValid = false;
    }
    if (this.dwpService.formData.sortCode.length < 6) {
      this.notificationService.printWarningMessage("Please enter 6 number sort code in format");
      this.isFormSubmitted = false;
      this.formValidityFlagLoaded.next();
      return this.isValid = false;
    }
    return this.isValid;
  }

  resetForm(form?: NgForm) {
    if (form = null)
      form.resetForm();
    this.dwpService.formData = {
      id: null,
      dwpName: '',
      bankName: '',
      sortCode: null,
      accountNumber: null,
      bacsAddressFirstLine: '',
      bacsAddressSecondLine: '',
      bacsAddressTown: '',
      bacsAddressPostCode: '',
      firstLine: '',
      secondLine: '',
      town: '',
      postCode: '',
      country: '',
      bacsCountry: '',
      bacsEmail: ''
    };
  }

  initializeForm(id) {
    this.dwpService.getDwpById(parseInt(id)).subscribe(res => {
      this.dwpService.formData = res;
      this.isInEditMode = true;
      this.form.form.markAsUntouched();
    },
      error => {
        this.notificationService.printErrorMessage('Error in fetching DWP Details');
      }
    );
  }

  refresh(): void {
    let id = this.activeRoute.snapshot.paramMap.get('dwpId');
    if (id == null) {
      this.resetForm();
      this.isInEditMode = false;
    }
    else {
      this.initializeForm(id);
      if (this.isInEditMode) {
        this.title = "Edit";
      } else { this.title = "Add"; }
    }
    this.form.form.markAsUntouched();
  }

  navigateToSearch(): void {
    this.router.navigate(['/search-participant']);
  }

}
